export type RetentionType = "SCREW_RETAINED" | "CEMENT_RETAINED";
export const RetentionTypeEnum: Record<RetentionType, RetentionType> = {
  SCREW_RETAINED: "SCREW_RETAINED",
  CEMENT_RETAINED: "CEMENT_RETAINED",
};

export interface ImplantedItemCharacteristics {
  retentionType: RetentionType;
}

export type StandardAbutmentType = "STANDARD" | "STANDARD_GENERIC";
export const StandardAbutmentTypeEnum: Record<
  StandardAbutmentType,
  StandardAbutmentType
> = {
  STANDARD: "STANDARD",
  STANDARD_GENERIC: "STANDARD_GENERIC",
};

export type CustomAbutmentType = "CUSTOM";
export const CustomAbutmentTypeEnum: Record<
  CustomAbutmentType,
  CustomAbutmentType
> = {
  CUSTOM: "CUSTOM",
};

export type AbutmentType = StandardAbutmentType | CustomAbutmentType;
export const AbutmentTypeEnum: Record<AbutmentType, AbutmentType> = {
  ...StandardAbutmentTypeEnum,
  ...CustomAbutmentTypeEnum,
};

interface BasedImplantCharacteristics {
  implantPlatform: string;
  scanBodyReference: string;
}

export interface ReferencedImplantCharacteristics extends BasedImplantCharacteristics {
  implantReferenceId: string;
}

export interface UnreferencedImplantCharacteristics extends BasedImplantCharacteristics {
  implantBrand: string;
  implantSystem: string;
}

export type ImplantCharacteristics =
  ReferencedImplantCharacteristics | UnreferencedImplantCharacteristics;
export interface StandardAbutmentCharacteristics {
  abutmentType:
    typeof AbutmentTypeEnum.STANDARD | typeof AbutmentTypeEnum.STANDARD_GENERIC;
  abutmentPreferences?: string;
}

export interface CustomAbutmentCharacteristics {
  abutmentType: typeof AbutmentTypeEnum.CUSTOM;
}

export type AbutmentCharacteristics =
  StandardAbutmentCharacteristics | CustomAbutmentCharacteristics;

export interface ImplantReference {
  id: string;
  brand: string;
  reference: string;
  platforms: string[];
}
